import { Injectable } from '@angular/core';
import { DataCoreService } from '../../../../services/data-core.service';
import { CtlBysIlgiGelenService } from '../../ctl-bys-ilgi-gelen/ctl-bys-ilgi-gelen.service';
import { CtlBysDetayService } from '../ctl-bys-detay.service';

@Injectable(

)
export class CtlBysDetayAramaService {

  constructor(private dataCoreService: DataCoreService, private service: CtlBysDetayService) {}

  getData(control: any) {
          const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
       //   dataSource.select(['Kod','BelgeAdi', 'BysBelgeDetay.Kod']);
         // const filterArr = [];
         // filterArr.push(['BelgeTuru', '=', 'E']);
        //  filterArr.push(['SurecKod', '<>', null]);
         // dataSource.filter(filterArr)
          return dataSource;
  }}
